export default "__VITE_ASSET__BekOmgyp__"